import type { Dictionary } from '../types'

export const tr: Dictionary = {
  /* ─── Settings (General / Security / Messaging) ───────────────────────── */
  settings: {
    title: 'Genel Ayarlar',
    subtitle:
      'Mağaza kimliği, davranış, hedef ve önbellek ayarları. OAuth, captcha ve ağ güvenliği için',
    subtitleLink: 'Güvenlik & Erişim',
    settingGroups: 'Ayar grupları',
    settingsLoadFailed: 'Ayarlar yüklenemedi.',
    loadingSettings: 'Ayarlar yükleniyor…',
    noConfigFound: 'Bu bölüm için yapılandırma kaydı bulunamadı.',
    saved: 'Ayarlar kaydedildi.',
    saveFailed: 'Kayıt başarısız',
    tabs: {
      general: 'Genel Ayarlar',
      storeBehavior: 'Mağaza Davranışı',
      socialMedia: 'Sosyal Medya',
      goal: 'Hedef Ayarları',
      cache: 'Önbellek Ayarları',
    },
    security: {
      title: 'Güvenlik & Erişim',
      subtitle:
        'Doğrulama, OTP, giriş doğrulama (captcha & OAuth) ve Cloudflare ağ güvenliği.',
      tabs: {
        verification: 'Doğrulama',
        otp: 'OTP',
        login: 'Giriş & Doğrulama',
        encryption: 'Veri Şifreleme',
        network: 'Ağ Güvenliği',
      },
      network: {
        cfWarning:
          'Cloudflare bağlantısı kurulamadı. Platform CF token ve domain zone kaydını kontrol edin.',
        vitrinAccess: 'Vitrin — ülke erişimi',
        geoPresets: {
          open: 'Herkes açık',
          trOnly: 'Sadece TR',
          blockTr: 'TR kapalı',
          custom: 'Özel liste',
        },
        geoEnabled: 'Ülke izin listesi aktif',
        vitrinIp: 'Vitrin IP izin listesi',
        vitrinIpNote: 'Yalnızca {host} için geçerlidir.',
        ipEnabled: 'IP izin listesi aktif',
        ipPlaceholder: 'Her satıra bir IP (ör. 1.2.3.4)',
        adminIp: 'Admin IP izin listesi',
        adminIpNote: 'Yalnızca {host} için geçerlidir.',
        adminIpEnabled: 'Admin IP kısıtı aktif',
        addMyIp: "Mevcut IP'mi ekle",
        ipFailed: 'IP alınamadı',
        allowBots: 'Doğrulanmış botlara izin ver',
        devMode: 'Geliştirici modu',
        operations: 'İşlemler',
        saveSync: 'Kaydet & CF Senkron',
        syncSuccess: 'Ağ güvenliği Cloudflare ile senkronlandı.',
        syncFailed: 'Senkron başarısız',
        lastSync: 'Son senkron: {date}',
        cfDisconnected: 'Cloudflare bağlantısı yok — DNS kayıtları listelenemiyor.',
        noData: 'Tabloda herhangi bir veri mevcut değil',
        sunucuIp: 'Sunucu IP',
        vitrinHost: 'Vitrin host',
        adminHost: 'Admin host',
      },
      dns: {
        title: 'DNS kayıtları',
        subtitle:
          'Kök, www, admin, api A/CNAME, MX ve Amazon SES kayıtları sistem tarafından korunur.',
        addRecord: 'Kayıt ekle',
        protectedNotice:
          'Korumalı DNS kayıtları düzenlenemez veya silinemez. Yeni kayıtlar yalnızca korumasız alt alan adları için eklenebilir.',
        type: 'Tip',
        name: 'İsim',
        content: 'İçerik',
        contentPlaceholder: 'IP veya hedef',
        proxy: 'Proxy',
        ttl: 'TTL',
        auto: 'Otomatik',
        status: 'Durum',
        protected: 'Korumalı',
        cfProxy: 'Cloudflare proxy (turuncu bulut)',
        addSuccess: 'DNS kaydı eklendi.',
        addFailed: 'DNS kaydı eklenemedi.',
        namePlaceholder: 'sub.domain.com',
      },
    },
    messaging: {
      title: 'Mesajlaşma entegrasyonları',
      subtitle: 'WhatsApp, Telegram ve sipariş mesaj taslakları tek panelden yönetilir.',
      tabs: {
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        templates: 'Mesaj Taslakları',
      },
      whatsapp: {
        title: 'WhatsApp Ayarları',
        subtitle: 'Meta Business Cloud API bağlantı bilgileri',
        webhookTitle: 'Webhook URL',
        webhookInstruction: "Meta Developer Console'da aşağıdaki URL'yi kaydedin:",
        webhookTokenHint: 'Doğrulama token\'ı olarak aşağıdaki "Verify Token" değerini kullanın.',
        saved: 'Ayarlar kaydedildi.',
        saving: 'Kaydediliyor…',
        save: 'Ayarları Kaydet',
        phoneIdLabel: 'Phone Number ID *',
        phoneIdHint: 'Meta Developer → WhatsApp → API Setup → Phone Number ID',
        accessTokenLabel: 'Access Token *',
        accessTokenHint: 'Permanent Token (System User) kullanmanız önerilir',
        verifyTokenLabel: 'Verify Token *',
        verifyTokenHint:
          'Kendiniz belirlediğiniz bir değer — webhook doğrulamasında kullanılır',
        noteTitle: 'Not',
        noteBody: 'Bu ayarlar config/services.php ve .env üzerinden de yönetilebilir:',
        noteFooter: "DB'den okunan ayarlar .env değerlerini ezer.",
      },
    },
  },

  /* ─── Panel Settings ───────────────────────────────────────────────────── */
  panel: {
    title: 'Panel Ayarları',
    subtitle: 'Admin panelinin görünüm, davranış ve arayüz çevirileri',
    tabs: {
      settings: 'Ayarlar',
      adminUi: 'Admin UI Çevirileri',
    },
    sections: {
      general: 'Genel',
      login: 'Giriş Sayfası',
      notifications: 'Bildirimler',
      security: 'Güvenlik',
      maintenance: 'Bakım Modu',
    },
    saveSuccess: 'Panel ayarları kaydedildi.',
    saveFailed: 'Kayıt başarısız',
    loadError: 'Ayarlar yüklenemedi.',
    ui: {
      hint: '<strong>Tablo:</strong> tek tek düzenle. <strong>JSON:</strong> dosyayı kopyala → AI\'ya ver → çevirilmiş JSON\'u yapıştır → kaydet.',
      hintPlain:
        'Tablo: tek tek düzenleyin. JSON: dosyayı kopyalayın → AI’ya verin → çeviriyi yapıştırıp kaydedin. Büyük katalogda grup filtresi ve sayfalama kullanın.',
      searchPlaceholder: 'Anahtar veya metin ara…',
      allGroups: 'Tüm gruplar',
      saveCount: '{count} çeviri kaydedildi',
      saveFailed: 'Kayıt başarısız',
      importSuccess: 'JSON içe aktarıldı: {count} kayıt',
      importFailed: 'JSON kaydı başarısız',
      seedSuccess: 'Varsayılanlar: {inserted} eklendi, {skipped} atlandı',
      seedFailed: 'Seed başarısız',
      copyOneLang: '{lang} JSON panoya kopyalandı',
      copyAllLangs: 'Tüm diller JSON olarak kopyalandı',
      copyFailed: 'Kopyalama başarısız',
      saveJson: "JSON'u kaydet",
      resetJson: 'Sıfırla',
      copyLang: '{lang} kopyala',
      copyAll: 'Tüm dilleri kopyala',
      empty: 'Çeviri bulunamadı. "Varsayılanları yükle" ile kataloğu oluşturun.',
      loadFailed: 'Çeviri kataloğu yüklenemedi. Migration ve seed’i kontrol edin.',
      showing: '{from}–{to} / {total} anahtar',
      key: 'Anahtar',
      custom: 'Özel',
      jsonHint:
        'İpucu: Önce TR veya EN\'yi kopyala → AI\'ya "aynı anahtarlarla DE JSON üret" de → dönen JSON\'u buraya yapıştır → <strong>JSON\'u kaydet</strong>. Tek dil düz obje yapıştırırsan soldaki hedef dil kullanılır.',
      jsonHintPlain:
        'İpucu: TR/EN JSON’u kopyalayın → AI ile hedef dili üretin → buraya yapıştırıp “JSON’u kaydet” deyin. Tek dil düz obje yapıştırırsanız soldaki hedef dil kullanılır.',
      parseError: 'JSON bir nesne olmalı',
      formatError: 'Format: { "de": { "nav.cart": "..." } } veya tek dil { "nav.cart": "..." }',
      ariaLabel: 'Admin UI çevirileri JSON',
      ariaSearch: 'Çeviri ara',
      ariaGroupFilter: 'Grup filtresi',
      ariaLangCopy: 'Tek dil kopyala / düz JSON hedef dili',
    },
  },

  /* ─── Integrations ─────────────────────────────────────────────────────── */
  integrations: {
    active: 'Aktif',
    inactive: 'Pasif',
    default: 'Varsayılan',
    saveSuccess: '{name} ayarları kaydedildi.',
    saveFailed: 'Ayarlar kaydedilirken bir hata oluştu.',
    logoText: 'Logo',
    customerTypes: {
      title: 'Müşteri tipleri',
      hint: 'Hiçbiri seçilmezse tüm müşterilere görünür. Seçilen tipler (ör. Bayi) yalnızca o gruba gösterilir.',
    },
    section: {
      policy: 'Politika',
      providers: 'Sağlayıcılar',
      accounts: 'Hesaplar',
      integrators: 'Entegratörler',
    },
    payments: {
      title: 'Ödeme İşlemcileri',
      subtitle:
        'Her yöntemi açarak Aktif yapın. Pasif yöntemler vitrinde gizlenir. Müşteri tipi seçerek Bayi / Normal gibi gruplara özel ödeme açabilirsiniz.',
      settingsTitle: 'Ödeme ayarları',
      settingsHint: 'Kart ile ödeme alındığında siparişe işlenecek ürün kimliği.',
      loadFailed: 'Ödeme yöntemleri yüklenemedi. Yetki veya API hatası olabilir.',
      retry: 'Tekrar dene',
      noProviders:
        'Henüz ödeme yöntemi kaydı yok. Tenant için PaymentApiSeeder çalıştırın, ardından sayfayı yenileyin.',
      activeHint: 'Aktif yöntemler sipariş ekranında görünür',
      defaultHint: 'Sepette ilk seçili gelir',
    },
    marketplaces: {
      title: 'Pazaryeri Entegrasyonları',
      subtitle:
        'Trendyol, Hepsiburada ve n11 kimlik bilgilerini buradan girin. Kanalı kaydettikten sonra bağlantıyı deneyin. Aktif olmayan kanallardan sipariş çekilmez.',
      loadFailed: 'Pazaryeri entegrasyonları yüklenemedi.',
      retry: 'Tekrar dene',
      noProviders: 'Pazaryeri kanalı bulunamadı.',
      activeHint: 'Aktif kanalın sipariş ve stok senkronu çalışır',
      test: 'Bağlantıyı dene',
      testHint: 'Önce kaydedin, sonra bu kanalın API bilgisiyle bağlantıyı sınayın.',
      testOk: 'Bağlantı başarılı.',
      testFailed: 'Bağlantı denemesi başarısız.',
    },
    cargo: {
      title: 'Kargo Firmaları',
      subtitle: 'Logolar her zaman görünür; ayarları değiştirmek için satıra tıklayın.',
      noProviders: 'Herhangi bir kargo entegratörü bulunamadı.',
      activeHint: 'Kargo barkodu oluşturabilir ve takip edebilirsiniz',
      defaultHint: 'Siparişlerde otomatik seçili gelir',
    },
    invoice: {
      title: 'e-Fatura Entegratörleri',
      titleEmpty: 'e-Fatura',
      subtitle: 'Logolar her zaman görünür; ayarları değiştirmek için satıra tıklayın.',
      noProvidersHint:
        'e-Fatura modülü aktif değil veya entegratör tanımlı değil. Fatura politikasını yine de güncelleyebilirsiniz.',
      policy: 'Fatura politikası',
      policyHint: 'Fatura kesim gecikmesi ve fatura e-posta adresi.',
      activeHint: 'Arka planda e-fatura kesimi yapabilir',
      defaultHint: 'Yeni siparişlerde birincil öncelikli API olarak kur',
      guideParasutTitle: 'Paraşüt bağlama',
      guideParasutIntro: 'Faturalar Paraşüt üzerinden kesilir ve müşteriye gider. Alanları bu sırayla doldurun.',
      guideParasut1: 'Client ID ve Client Secret değerlerini Paraşüt canlı destek veya e-posta ile isteyin. Gelen değerleri bu karttaki alanlara yazın.',
      guideParasut2: 'Kullanıcı adı ve şifre, Paraşüt’e girişte kullandığınız bilgilerdir.',
      guideParasut3: 'Redirect adresi sabittir (urn:ietf:wg:oauth:2.0:oob). Bu alana bir şey yazmayın.',
      guideParasut4: 'Firma No: Paraşüt’e girin. Adres çubuğundaki rakam Firma No’dur. Örnek: uygulama.parasut.com/12345 → 12345.',
      guideParasut5: 'Kasa hesabı panelde ayrı kutu değildir. Paraşüt’te Nakit → Kasa ve Bankalar → Kasa Hesabı açın; adres sonundaki numara o hesaba aittir. Fatura şablonunda bu hesabı kullanın.',
      guideParasutTemplate: 'Fatura şablonunu Paraşüt’te oluşturun',
      guideBirfaturaTitle: 'BirFatura bağlama',
      guideBirfaturaIntro: 'BirFatura hesabınız yoksa önce kayıt olun. Sonra mağazanızı ekleyin.',
      guideBirfaturaSignup: 'Kayıt',
      guideBirfaturaStore: 'Mağaza Ayarları',
      guideBirfaturaCompany: 'Firma Bilgileri',
      guideBirfaturaTemplate: 'Fatura şablonu',
      guideBirfatura1: 'sayfasının altındaki Özel entegrasyon bölümünden Yeni Mağaza Ekle deyin.',
      guideBirfatura2: 'Web sitenizin adresi ve Satış Kanalı Url alanlarına aşağıdaki vitrin adresini yazın.',
      guideBirfatura3: 'BirFatura’daki API Şifresi ile bu karttaki API Şifresi aynı olsun.',
      guideBirfatura4: 'sayfasında "Özelleştirme Ayarları" bölümünde şu iki kutuyu işaretleyin: “Siparişler, Faturalar Sayfasına Otomatik Aktarılsın” ve “Siparişlerden Faturalar Sayfasına Aktarılanların E-Faturası Otomatik Kesilsin”.',
      guideBirfatura5: 'hazırlamayı unutmayın.',
    },
    bankAccounts: {
      title: 'Havale / EFT Hesapları',
      subtitle: 'Müşterilerin ödeme yapacağı mağaza banka hesapları',
      addBtn: 'Hesap Ekle',
      empty: 'Henüz havale hesabı tanımlanmamış.',
      loadError: 'Banka listesi yüklenemedi veya boş. Lütfen sayfayı yenileyin.',
      editTitle: 'Hesabı Düzenle',
      newTitle: 'Yeni Havale Hesabı',
      bank: 'Banka',
      accountHolder: 'Hesap sahibi',
      iban: 'IBAN',
      branch: 'Şube adı',
      branchCode: 'Şube kodu',
      updateSuccess: 'Hesap güncellendi',
      createSuccess: 'Hesap eklendi',
      saveError: 'Kayıt başarısız',
      deleteSuccess: 'Hesap silindi',
    },
  },

  /* ─── SMS ──────────────────────────────────────────────────────────────── */
  sms: {
    title: 'SMS Sağlayıcı',
    subtitle:
      'API kullanıcı adı, şifre ve gönderici başlığı bu panelden girilir — sunucu .env dosyasına gerek yoktur.',
    loadFailed: 'SMS sağlayıcıları yüklenemedi.',
    noProviders: 'Henüz SMS sağlayıcı eklenmedi. Aşağıdaki satırdan ekleyebilirsiniz.',
    displayName: 'Görünen ad',
    providerKey: 'Sağlayıcı anahtarı',
    activeHint: "OTP ve bildirim SMS'leri bu sağlayıcı üzerinden gönderilebilir",
    defaultHint: 'Birden fazla sağlayıcı varsa öncelikli olan',
    apiCredentials: 'API kimlik bilgileri',
    noApiFields:
      'Bu sağlayıcı için tanımlı API alanı yok. Desteklenen sağlayıcılar: NetGSM, İleti Merkezi, VatanSMS.',
    updateSuccess: '{name} güncellendi.',
    updateFailed: 'Kayıt başarısız.',
    deleteSuccess: 'Sağlayıcı silindi.',
    deleteFailed: 'Silme başarısız.',
    deleteConfirm: '{name} silinsin mi?',
    addProvider: 'Yeni sağlayıcı ekle',
    addProviderHint:
      'NetGSM, İleti Merkezi veya VatanSMS — kimlik bilgileri ekleme sonrası panelden girilir',
    selectProviderLabel: 'Sağlayıcı *',
    selectPlaceholder: '— Seçiniz —',
    customProvider: 'Özel sağlayıcı…',
    keyLabel: 'Anahtar (key) *',
    nameLabel: 'Görünen ad *',
    defaultSingleHint: 'İlk tercih edilen SMS sağlayıcısı',
    activeImmediately: 'Hemen kullanıma açılsın',
    addAfterHint:
      'Sağlayıcı eklendikten sonra API kullanıcı adı, şifre ve gönderici başlığını açılan panelden girebilirsiniz.',
    createSuccess: 'SMS sağlayıcı eklendi.',
    createFailed: 'Sağlayıcı eklenemedi.',
    addBtn: 'Ekle',
  },

  /* ─── Shipping ─────────────────────────────────────────────────────────── */
  shipping: {
    title: 'Kargo Yöntemleri',
    subtitle: 'Müşterilerinize sunulan teslimat seçenekleri',
    addNew: 'Yeni Yöntem',
    newFormTitle: 'Yeni Kargo Yöntemi',
    editFormTitle: 'Düzenle — {name}',
    nameLabel: 'Ad *',
    namePlaceholder: 'ör. Standart Kargo',
    providerLabel: 'Tedarikçi',
    providerPlaceholder: 'ör. MNG, Aras',
    priceLabel: 'Ücret (₺) *',
    freeAboveLabel: 'Ücretsiz eşiği (₺)',
    freeAbovePlaceholder: 'Boş bırakılırsa yok',
    estimatedLabel: 'Tahmini teslimat',
    estimatedPlaceholder: 'ör. 2-3 iş günü',
    createSuccess: 'Kargo yöntemi oluşturuldu.',
    createFailed: 'Oluşturulamadı',
    saveSuccess: 'Kaydedildi.',
    updateFailed: 'Güncellenemedi',
    deleteSuccess: 'Silindi.',
    deleteFailed: 'Silinemedi',
    empty: 'Henüz kargo yöntemi yok.',
    deleteConfirm: '"{name}" silinsin mi?',
  },

  /* ─── Modules ──────────────────────────────────────────────────────────── */
  modules: {
    title: 'Plan & Modüller',
    subtitle:
      'Aşağıdaki liste salt okunurdur. Hangi özelliklerin mağazanızda kullanılabileceği platform yöneticisi (super-admin) tarafından plan veya tenant özel ayarı ile belirlenir. Kapalı modüller menüde görünmez; doğrudan URL ile erişimde de engellenir.',
    enabledCount: 'Açık modül',
    disabledCount: 'Kapalı modül',
    storeType: 'Mağaza tipi',
    loadFailed:
      'Modül listesi yüklenemedi. Oturumunuzu kontrol edip sayfayı yenileyin.',
    col: {
      module: 'Modül',
      status: 'Durum',
      quotas: 'Kotalar',
      source: 'Kaynak',
      description: 'Açıklama',
    },
    statusOpen: 'Açık',
    statusClosed: 'Kapalı',
    expires: 'Bitiş: {date}',
    footer:
      'Bir modülü açtırmak veya planınızı yükseltmek için platform yöneticinizle (super-admin) iletişime geçin. Mağaza panelinde modül durumu değiştirilemez.',
    groups: {
      commerce: 'Ticaret',
      content: 'İçerik',
      communication: 'İletişim',
      analytics: 'Analitik',
      integration: 'Entegrasyon',
      gamification: 'Oyunlaştırma',
      future: 'Gelecek',
    },
    source: {
      override: 'Platform yöneticisi (özel ayar)',
      plan: 'Abonelik planı',
      default: 'Katalog varsayılanı',
    },
    notice: {
      title: 'Özellikler platform yöneticisi tarafından yönetilir',
      body: 'Bu mağazada hangi modüllerin açık olacağı super-admin panelindeki <strong>abonelik planı</strong> veya <strong>tenant modül ayarları</strong> ile belirlenir. Mağaza panelinden modül açıp kapatamazsınız; yalnızca açık olan özellikleri kullanırsınız.',
      status: 'Durum: <strong>{enabled}</strong> açık / <strong>{disabled}</strong> kapalı modül',
      viewAll: 'Tüm modül listesini görüntüle',
      dismiss: 'Uyarıyı kapat',
    },
    gate: {
      checking: 'Modül durumu kontrol ediliyor…',
      closed: '{name} — kapalı',
      noAccess:
        'Bu özellik mağaza panelinden açılamaz. Erişim, platform yöneticisinin (super-admin) atadığı plan veya tenant modül ayarı ile belirlenir.',
      sourceHint: {
        override: 'Platform yöneticisi bu modülü özel olarak kapattı veya süreli olarak açtı.',
        plan: 'Abonelik planınızda bu modül kapalı.',
        default:
          'Modül katalogda varsayılan olarak kapalı; plan veya platform ayarı gerekir.',
      },
      notAvailable: 'Modül şu an kullanılamıyor.',
      viewAll: 'Tüm modül durumlarını görüntüle',
    },
  },

  /* ─── TopUp ────────────────────────────────────────────────────────────── */
  topup: {
    title: 'TopUp Bot Yönetimi',
    subtitle: 'Otomatik stok senkronizasyonu için bot sunucularını yönetin.',
    tabs: {
      bots: 'Botlar',
      products: 'Ürünler',
      logs: 'Loglar',
      botsHint: 'Sunucu ve stok senkronu',
      productsHint: 'Bota bağlı ürünler',
      logsHint: 'Başarılı ve hatalı işlemler',
    },
    bots: {
      addBtn: '+ Bot Ekle',
      loading: 'Yükleniyor…',
      empty: 'Henüz bot eklenmedi.',
      sync: '↻ Senkronize Et',
      syncing: 'Senkronize…',
      syncSuccess: '{synced} ürün senkronize edildi',
      syncErrors: ', {errors} hata',
      syncFailed: 'Senkronizasyon başarısız.',
      deactivate: 'Pasife Al',
      activate: 'Aktive Et',
      deleteConfirm: 'Bot silinsin mi?',
    },
    products: {
      searchPlaceholder: 'Ürün adı veya anahtar ara…',
      loading: 'Yükleniyor…',
      nameCol: 'Ürün Adı',
      keyCol: 'Anahtar (key)',
      addedCol: 'Eklenme',
      empty: 'Ürün bulunamadı. Bot senkronizasyonu çalıştırdığınızda ürünler otomatik eklenir.',
    },
    logs: {
      allStatuses: 'Tüm Durumlar',
      successStatus: 'Başarılı',
      errorStatus: 'Hata',
      loading: 'Yükleniyor…',
      empty: 'Log bulunamadı.',
      botCol: 'Bot',
      typeCol: 'Tür',
      messageCol: 'Mesaj',
      statusCol: 'Durum',
      dateCol: 'Tarih',
    },
    form: {
      editTitle: 'Bot Düzenle',
      newTitle: 'Yeni Bot',
      serverInfo: 'Sunucu Bilgileri',
      nameLabel: 'Bot Adı *',
      ipLabel: 'IP Adresi *',
      portLabel: 'Port *',
      tokenLabel: 'API Token *',
      tokenEditHint: '(boş bırakırsan değişmez)',
      midasbuy: 'MidasBuy (İsteğe Bağlı)',
      unipin: 'UniPin (İsteğe Bağlı)',
      securityKey: 'Güvenlik Anahtarı',
      saving: 'Kaydediliyor…',
    },
  },

  /* ─── AI ───────────────────────────────────────────────────────────────── */
  ai: {
    title: 'AI Ayarları',
    subtitle:
      'Ürün açıklaması ve SEO meta verisi oluşturmak için kullanılacak yapay zeka sağlayıcısını yapılandırın.',
    saved: 'AI ayarları kaydedildi.',
    saveFailed: 'Kayıt başarısız.',
    provider: {
      sectionTitle: 'Sağlayıcı',
      selectLabel: 'AI Sağlayıcı',
      ollamaLocal: 'Ollama (Yerel)',
    },
    openai: {
      title: 'OpenAI Ayarları',
      apiKeyLabel: 'API Anahtarı',
      apiKeyHint: 'sk-... ile başlayan OpenAI API anahtarı',
      modelLabel: 'Model',
      modelHint: 'Boşsa varsayılan: gpt-4o-mini',
    },
    ollama: {
      title: 'Ollama Ayarları',
      baseUrlLabel: 'Base URL',
      baseUrlHint: 'Varsayılan: http://localhost:11434',
      modelLabel: 'Model',
      modelHint: 'Boşsa varsayılan: llama3.2',
    },
    test: {
      title: 'Bağlantı Testi',
      hint: 'Kaydetmeden önce mevcut yapılandırmanın çalışıp çalışmadığını test edin.',
      btn: 'Bağlantıyı Test Et',
      testing: 'Test ediliyor…',
      success: 'Bağlantı başarılı.',
      failed: 'Bağlantı başarısız. API anahtarı ve ayarları kontrol edin.',
    },
    quota: {
      title: 'Aylık AI üretimi (paket kotası)',
      unlimited: 'Planda aylık üst sınır tanımlı değil (sınırsız).',
      usage: '{current} / {limit} kullanıldı',
      percent: ' ({percent}%)',
    },
    usageInfo: {
      title: 'Nerede kullanılır?',
      descriptionItem: 'Ürün formunda uzun açıklama oluşturma',
      seoItem: 'SEO sekmesinde meta başlık ve açıklama üretme',
      moduleNote:
        'Bu modülün aktif olması için <strong>Modüller</strong> sayfasından <em>ai_suggestions</em> modülünü etkinleştirin.',
    },
    generate: {
      descriptionBtn: 'AI ile Oluştur',
      descriptionLoading: 'Yazıyor…',
      metaBtn: 'AI ile Doldur',
      metaLoading: 'Üretiliyor…',
      noProductName: 'Önce ürün adını girin.',
      descriptionSuccess: 'Açıklama oluşturuldu.',
      descriptionFailed: 'AI açıklama üretemedi. API ayarlarını kontrol edin.',
      metaSuccess: 'SEO meta verileri oluşturuldu.',
      metaFailed: 'AI meta verisi üretemedi. API ayarlarını kontrol edin.',
    },
  },
}

export const en: Dictionary = {
  settings: {
    title: 'General Settings',
    subtitle:
      'Store identity, behavior, goals and cache settings. For OAuth, captcha and network security, visit',
    subtitleLink: 'Security & Access',
    settingGroups: 'Setting groups',
    settingsLoadFailed: 'Failed to load settings.',
    loadingSettings: 'Loading settings…',
    noConfigFound: 'No configuration records found for this section.',
    saved: 'Settings saved.',
    saveFailed: 'Save failed',
    tabs: {
      general: 'General Settings',
      storeBehavior: 'Store Behavior',
      socialMedia: 'Social Media',
      goal: 'Goal Settings',
      cache: 'Cache Settings',
    },
    security: {
      title: 'Security & Access',
      subtitle:
        'Verification, OTP, login verification (captcha & OAuth) and Cloudflare network security.',
      tabs: {
        verification: 'Verification',
        otp: 'OTP',
        login: 'Login & Verification',
        encryption: 'Data Encryption',
        network: 'Network Security',
      },
      network: {
        cfWarning:
          'Cloudflare connection failed. Check platform CF token and domain zone record.',
        vitrinAccess: 'Storefront — country access',
        geoPresets: {
          open: 'Everyone open',
          trOnly: 'TR only',
          blockTr: 'Block TR',
          custom: 'Custom list',
        },
        geoEnabled: 'Country allow-list active',
        vitrinIp: 'Storefront IP allow-list',
        vitrinIpNote: 'Applies only to {host}.',
        ipEnabled: 'IP allow-list active',
        ipPlaceholder: 'One IP per line (e.g. 1.2.3.4)',
        adminIp: 'Admin IP allow-list',
        adminIpNote: 'Applies only to {host}.',
        adminIpEnabled: 'Admin IP restriction active',
        addMyIp: 'Add my current IP',
        ipFailed: 'Failed to retrieve IP',
        allowBots: 'Allow verified bots',
        devMode: 'Developer mode',
        operations: 'Actions',
        saveSync: 'Save & CF Sync',
        syncSuccess: 'Network security synced with Cloudflare.',
        syncFailed: 'Sync failed',
        lastSync: 'Last sync: {date}',
        cfDisconnected: 'No Cloudflare connection — DNS records cannot be listed.',
        noData: 'No data in table',
        sunucuIp: 'Server IP',
        vitrinHost: 'Storefront host',
        adminHost: 'Admin host',
      },
      dns: {
        title: 'DNS records',
        subtitle:
          'Root, www, admin, api A/CNAME, MX and Amazon SES records are protected by the system.',
        addRecord: 'Add record',
        protectedNotice:
          'Protected DNS records cannot be edited or deleted. New records can only be added for unprotected subdomains.',
        type: 'Type',
        name: 'Name',
        content: 'Content',
        contentPlaceholder: 'IP or target',
        proxy: 'Proxy',
        ttl: 'TTL',
        auto: 'Auto',
        status: 'Status',
        protected: 'Protected',
        cfProxy: 'Cloudflare proxy (orange cloud)',
        addSuccess: 'DNS record added.',
        addFailed: 'Failed to add DNS record.',
        namePlaceholder: 'sub.domain.com',
      },
    },
    messaging: {
      title: 'Messaging integrations',
      subtitle: 'WhatsApp, Telegram and order message templates managed from one panel.',
      tabs: {
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        templates: 'Message Templates',
      },
      whatsapp: {
        title: 'WhatsApp Settings',
        subtitle: 'Meta Business Cloud API connection details',
        webhookTitle: 'Webhook URL',
        webhookInstruction: 'Register the following URL in Meta Developer Console:',
        webhookTokenHint: 'Use the "Verify Token" below as the verification token.',
        saved: 'Settings saved.',
        saving: 'Saving…',
        save: 'Save Settings',
        phoneIdLabel: 'Phone Number ID *',
        phoneIdHint: 'Meta Developer → WhatsApp → API Setup → Phone Number ID',
        accessTokenLabel: 'Access Token *',
        accessTokenHint: 'Using a Permanent Token (System User) is recommended',
        verifyTokenLabel: 'Verify Token *',
        verifyTokenHint: 'A value you define — used for webhook verification',
        noteTitle: 'Note',
        noteBody: 'These settings can also be managed via config/services.php and .env:',
        noteFooter: 'Settings read from DB override .env values.',
      },
    },
  },

  panel: {
    title: 'Panel Settings',
    subtitle: 'Admin panel appearance, behavior and UI translations',
    tabs: {
      settings: 'Settings',
      adminUi: 'Admin UI Translations',
    },
    sections: {
      general: 'General',
      login: 'Login Page',
      notifications: 'Notifications',
      security: 'Security',
      maintenance: 'Maintenance Mode',
    },
    saveSuccess: 'Panel settings saved.',
    saveFailed: 'Save failed',
    loadError: 'Failed to load settings.',
    ui: {
      hint: '<strong>Table:</strong> edit individually. <strong>JSON:</strong> copy file → pass to AI → paste translated JSON → save.',
      hintPlain:
        'Table: edit keys one by one. JSON: copy → send to AI → paste translation and save. Use group filter and pagination for the large catalog.',
      searchPlaceholder: 'Search key or text…',
      allGroups: 'All groups',
      saveCount: '{count} translations saved',
      saveFailed: 'Save failed',
      importSuccess: 'JSON imported: {count} records',
      importFailed: 'JSON save failed',
      seedSuccess: 'Defaults: {inserted} added, {skipped} skipped',
      seedFailed: 'Seed failed',
      copyOneLang: '{lang} JSON copied to clipboard',
      copyAllLangs: 'All languages copied as JSON',
      copyFailed: 'Copy failed',
      saveJson: 'Save JSON',
      resetJson: 'Reset',
      copyLang: 'Copy {lang}',
      copyAll: 'Copy all languages',
      empty: 'No translations found. Use "Load defaults" to build the catalog.',
      loadFailed: 'Could not load the translation catalog. Check migration and seed.',
      showing: '{from}–{to} / {total} keys',
      key: 'Key',
      custom: 'Custom',
      jsonHint:
        'Tip: Copy TR or EN first → ask AI "generate DE JSON with the same keys" → paste the result here → <strong>Save JSON</strong>. Pasting a flat object uses the target locale on the left.',
      jsonHintPlain:
        'Tip: Copy TR/EN JSON → generate the target language with AI → paste here and click “Save JSON”. A flat single-locale object uses the target language on the left.',
      parseError: 'JSON must be an object',
      formatError:
        'Format: { "de": { "nav.cart": "..." } } or single locale { "nav.cart": "..." }',
      ariaLabel: 'Admin UI translations JSON',
      ariaSearch: 'Search translation',
      ariaGroupFilter: 'Group filter',
      ariaLangCopy: 'Copy one locale / flat JSON target locale',
    },
  },

  integrations: {
    active: 'Active',
    inactive: 'Inactive',
    default: 'Default',
    saveSuccess: '{name} settings saved.',
    saveFailed: 'An error occurred while saving settings.',
    logoText: 'Logo',
    customerTypes: {
      title: 'Customer types',
      hint: 'If none selected, visible to all customers. Selected types (e.g. Reseller) are shown only to that group.',
    },
    section: {
      policy: 'Policy',
      providers: 'Providers',
      accounts: 'Accounts',
      integrators: 'Integrators',
    },
    payments: {
      title: 'Payment Processors',
      subtitle:
        'Enable each method by setting it Active. Inactive methods are hidden in the storefront. Select customer types to restrict payment to specific groups such as Reseller / Regular.',
      settingsTitle: 'Payment settings',
      settingsHint: 'Product ID to be applied to the order when payment is made by card.',
      loadFailed: 'Failed to load payment methods. Check permissions or API.',
      retry: 'Retry',
      noProviders:
        'No payment methods registered yet. Run PaymentApiSeeder for the tenant, then refresh.',
      activeHint: 'Active methods appear on the order screen',
      defaultHint: 'Pre-selected in the cart',
    },
    marketplaces: {
      title: 'Marketplace integrations',
      subtitle:
        'Enter Trendyol, Hepsiburada and n11 credentials here. Save the channel, then test the connection. Inactive channels are not synced.',
      loadFailed: 'Marketplace integrations could not be loaded.',
      retry: 'Retry',
      noProviders: 'No marketplace channel found.',
      activeHint: 'Order and stock sync runs for active channels',
      test: 'Test connection',
      testHint: 'Save first, then test this channel with the stored API credentials.',
      testOk: 'Connection succeeded.',
      testFailed: 'Connection test failed.',
    },
    cargo: {
      title: 'Cargo Companies',
      subtitle: 'Logos always visible; click a row to change settings.',
      noProviders: 'No cargo integrations found.',
      activeHint: 'Can generate cargo barcodes and track shipments',
      defaultHint: 'Auto-selected on orders',
    },
    invoice: {
      title: 'e-Invoice Integrations',
      titleEmpty: 'e-Invoice',
      subtitle: 'Logos always visible; click a row to change settings.',
      noProvidersHint:
        'e-Invoice module is not active or no integration is defined. You can still update the invoice policy.',
      policy: 'Invoice policy',
      policyHint: 'Invoice generation delay and invoice email address.',
      activeHint: 'Can issue e-invoices in the background',
      defaultHint: 'Set as the primary API for new orders',
      guideParasutTitle: 'Connect Paraşüt',
      guideParasutIntro: 'Invoices are issued and sent through Paraşüt. Fill the fields in this order.',
      guideParasut1: 'Ask Paraşüt live support or email for the Client ID and Client Secret, then paste them into this card.',
      guideParasut2: 'Username and password are the credentials you use to sign in to Paraşüt.',
      guideParasut3: 'The redirect address is fixed (urn:ietf:wg:oauth:2.0:oob). Do not enter it in the form.',
      guideParasut4: 'Company number: sign in to Paraşüt. The digits in the address bar are the company number. Example: uygulama.parasut.com/12345 → 12345.',
      guideParasut5: 'There is no separate cash-account field here. In Paraşüt open Cash → Cash and banks → Cash account. The number at the end of that address belongs to the account. Use it in the invoice template.',
      guideParasutTemplate: 'Create the invoice template in Paraşüt',
      guideBirfaturaTitle: 'Connect BirFatura',
      guideBirfaturaIntro: 'Create a BirFatura account first, then add your store.',
      guideBirfaturaSignup: 'Sign up',
      guideBirfaturaStore: 'Store settings',
      guideBirfaturaCompany: 'Company details',
      guideBirfaturaTemplate: 'Invoice template',
      guideBirfatura1: 'page, open Özel entegrasyon at the bottom and click Yeni Mağaza Ekle.',
      guideBirfatura2: 'Enter the storefront address below in both Web sitenizin adresi and Satış Kanalı Url.',
      guideBirfatura3: 'The API password in BirFatura and the API password on this card must match.',
      guideBirfatura4: 'page, enable “Siparişler, Faturalar Sayfasına Otomatik Aktarılsın” and “Siparişlerden Faturalar Sayfasına Aktarılanların E-Faturası Otomatik Kesilsin”.',
      guideBirfatura5: 'before you start issuing invoices.',
    },
    bankAccounts: {
      title: 'Bank Transfer / EFT Accounts',
      subtitle: 'Store bank accounts customers use for payment',
      addBtn: 'Add Account',
      empty: 'No bank transfer accounts defined yet.',
      loadError: 'Bank list could not be loaded or is empty. Please refresh the page.',
      editTitle: 'Edit Account',
      newTitle: 'New Bank Transfer Account',
      bank: 'Bank',
      accountHolder: 'Account holder',
      iban: 'IBAN',
      branch: 'Branch name',
      branchCode: 'Branch code',
      updateSuccess: 'Account updated',
      createSuccess: 'Account added',
      saveError: 'Save failed',
      deleteSuccess: 'Account deleted',
    },
  },

  sms: {
    title: 'SMS Provider',
    subtitle:
      'API username, password and sender name are entered from this panel — no server .env required.',
    loadFailed: 'Failed to load SMS providers.',
    noProviders: 'No SMS providers added yet. You can add one from the row below.',
    displayName: 'Display name',
    providerKey: 'Provider key',
    activeHint: 'OTP and notification SMS messages can be sent through this provider',
    defaultHint: 'Priority provider when multiple are configured',
    apiCredentials: 'API credentials',
    noApiFields:
      'No API fields defined for this provider. Supported: NetGSM, İleti Merkezi, VatanSMS.',
    updateSuccess: '{name} updated.',
    updateFailed: 'Save failed.',
    deleteSuccess: 'Provider deleted.',
    deleteFailed: 'Delete failed.',
    deleteConfirm: 'Delete {name}?',
    addProvider: 'Add new provider',
    addProviderHint: 'NetGSM, İleti Merkezi or VatanSMS — credentials can be entered after adding',
    selectProviderLabel: 'Provider *',
    selectPlaceholder: '— Select —',
    customProvider: 'Custom provider…',
    keyLabel: 'Key *',
    nameLabel: 'Display name *',
    defaultSingleHint: 'First preferred SMS provider',
    activeImmediately: 'Enable immediately',
    addAfterHint:
      'After adding the provider you can enter the API username, password and sender name from the expanded panel.',
    createSuccess: 'SMS provider added.',
    createFailed: 'Failed to add provider.',
    addBtn: 'Add',
  },

  shipping: {
    title: 'Shipping Methods',
    subtitle: 'Delivery options available to your customers',
    addNew: 'New Method',
    newFormTitle: 'New Shipping Method',
    editFormTitle: 'Edit — {name}',
    nameLabel: 'Name *',
    namePlaceholder: 'e.g. Standard Shipping',
    providerLabel: 'Provider',
    providerPlaceholder: 'e.g. UPS, FedEx',
    priceLabel: 'Rate (₺) *',
    freeAboveLabel: 'Free shipping threshold (₺)',
    freeAbovePlaceholder: 'Leave empty to disable',
    estimatedLabel: 'Estimated delivery',
    estimatedPlaceholder: 'e.g. 2–3 business days',
    createSuccess: 'Shipping method created.',
    createFailed: 'Failed to create',
    saveSuccess: 'Saved.',
    updateFailed: 'Failed to update',
    deleteSuccess: 'Deleted.',
    deleteFailed: 'Failed to delete',
    empty: 'No shipping methods yet.',
    deleteConfirm: 'Delete "{name}"?',
  },

  modules: {
    title: 'Plan & Modules',
    subtitle:
      'This list is read-only. Which features are available in your store is determined by the platform administrator (super-admin) via a plan or tenant-specific setting. Disabled modules are hidden from the menu and blocked on direct URL access.',
    enabledCount: 'Enabled modules',
    disabledCount: 'Disabled modules',
    storeType: 'Store type',
    loadFailed: 'Failed to load module list. Check your session and refresh.',
    col: {
      module: 'Module',
      status: 'Status',
      quotas: 'Quotas',
      source: 'Source',
      description: 'Description',
    },
    statusOpen: 'Open',
    statusClosed: 'Closed',
    expires: 'Expires: {date}',
    footer:
      'To enable a module or upgrade your plan, contact your platform administrator (super-admin). Module status cannot be changed from the store panel.',
    groups: {
      commerce: 'Commerce',
      content: 'Content',
      communication: 'Communication',
      analytics: 'Analytics',
      integration: 'Integration',
      gamification: 'Gamification',
      future: 'Future',
    },
    source: {
      override: 'Platform admin (custom setting)',
      plan: 'Subscription plan',
      default: 'Catalog default',
    },
    notice: {
      title: 'Features are managed by the platform administrator',
      body: 'Which modules are enabled in this store is determined by the <strong>subscription plan</strong> or <strong>tenant module settings</strong> in the super-admin panel. You cannot enable or disable modules from the store panel; you can only use what is already enabled.',
      status: 'Status: <strong>{enabled}</strong> enabled / <strong>{disabled}</strong> disabled',
      viewAll: 'View all modules',
      dismiss: 'Dismiss notice',
    },
    gate: {
      checking: 'Checking module status…',
      closed: '{name} — disabled',
      noAccess:
        'This feature cannot be enabled from the store panel. Access is determined by the plan or tenant module setting assigned by the platform administrator (super-admin).',
      sourceHint: {
        override: 'The platform admin specifically disabled or temporarily enabled this module.',
        plan: 'This module is disabled in your subscription plan.',
        default: 'Module is disabled by catalog default; a plan or platform setting is required.',
      },
      notAvailable: 'Module is currently unavailable.',
      viewAll: 'View all module statuses',
    },
  },

  topup: {
    title: 'TopUp Bot Management',
    subtitle: 'Manage bot servers for automatic stock synchronization.',
    tabs: {
      bots: 'Bots',
      products: 'Products',
      logs: 'Logs',
      botsHint: 'Server and stock sync',
      productsHint: 'Products linked to a bot',
      logsHint: 'Successful and failed runs',
    },
    bots: {
      addBtn: '+ Add Bot',
      loading: 'Loading…',
      empty: 'No bots added yet.',
      sync: '↻ Synchronize',
      syncing: 'Syncing…',
      syncSuccess: '{synced} products synchronized',
      syncErrors: ', {errors} errors',
      syncFailed: 'Synchronization failed.',
      deactivate: 'Deactivate',
      activate: 'Activate',
      deleteConfirm: 'Delete bot?',
    },
    products: {
      searchPlaceholder: 'Search product name or key…',
      loading: 'Loading…',
      nameCol: 'Product Name',
      keyCol: 'Key',
      addedCol: 'Added',
      empty: 'No products found. Products are added automatically when you run bot sync.',
    },
    logs: {
      allStatuses: 'All Statuses',
      successStatus: 'Success',
      errorStatus: 'Error',
      loading: 'Loading…',
      empty: 'No logs found.',
      botCol: 'Bot',
      typeCol: 'Type',
      messageCol: 'Message',
      statusCol: 'Status',
      dateCol: 'Date',
    },
    form: {
      editTitle: 'Edit Bot',
      newTitle: 'New Bot',
      serverInfo: 'Server Details',
      nameLabel: 'Bot Name *',
      ipLabel: 'IP Address *',
      portLabel: 'Port *',
      tokenLabel: 'API Token *',
      tokenEditHint: '(leave empty to keep unchanged)',
      midasbuy: 'MidasBuy (Optional)',
      unipin: 'UniPin (Optional)',
      securityKey: 'Security Key',
      saving: 'Saving…',
    },
  },

  ai: {
    title: 'AI Settings',
    subtitle:
      'Configure the AI provider to be used for generating product descriptions and SEO metadata.',
    saved: 'AI settings saved.',
    saveFailed: 'Save failed.',
    provider: {
      sectionTitle: 'Provider',
      selectLabel: 'AI Provider',
      ollamaLocal: 'Ollama (Local)',
    },
    openai: {
      title: 'OpenAI Settings',
      apiKeyLabel: 'API Key',
      apiKeyHint: 'OpenAI API key starting with sk-...',
      modelLabel: 'Model',
      modelHint: 'Default if empty: gpt-4o-mini',
    },
    ollama: {
      title: 'Ollama Settings',
      baseUrlLabel: 'Base URL',
      baseUrlHint: 'Default: http://localhost:11434',
      modelLabel: 'Model',
      modelHint: 'Default if empty: llama3.2',
    },
    test: {
      title: 'Connection Test',
      hint: 'Test whether the current configuration works before saving.',
      btn: 'Test Connection',
      testing: 'Testing…',
      success: 'Connection successful.',
      failed: 'Connection failed. Check the API key and settings.',
    },
    quota: {
      title: 'Monthly AI generation (plan quota)',
      unlimited: 'No monthly limit defined in plan (unlimited).',
      usage: '{current} / {limit} used',
      percent: ' ({percent}%)',
    },
    usageInfo: {
      title: 'Where is it used?',
      descriptionItem: 'Generating long descriptions in the product form',
      seoItem: 'Generating meta title and description in the SEO tab',
      moduleNote:
        'To use this module, enable the <em>ai_suggestions</em> module from the <strong>Modules</strong> page.',
    },
    generate: {
      descriptionBtn: 'Generate with AI',
      descriptionLoading: 'Writing…',
      metaBtn: 'Fill with AI',
      metaLoading: 'Generating…',
      noProductName: 'Enter a product name first.',
      descriptionSuccess: 'Description generated.',
      descriptionFailed: 'AI could not generate a description. Check API settings.',
      metaSuccess: 'SEO metadata generated.',
      metaFailed: 'AI could not generate metadata. Check API settings.',
    },
  },
}
